import React from 'react';
import styled from 'styled-components';

import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Txt from '../../atoms/Txt';
import Col from '../../atoms/FlexColumn';
import Row from '../../atoms/FlexRow';
import { logOut } from '../../../store/ducks/auth';

const Container = styled.ul`
  flex: 1;
  list-style: none;
  display: flex;
  flex-flow: column nowrap;
  background-color: #002666;
  position: fixed;
  transform: ${({ open }) => (open ? 'translateY(0)' : 'translateY(-100%)')};
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  padding-top: 100px;
  transition: transform 0.6s ease-in-out;
  z-index: 2;

  i {
    margin: 8px 8px;
    font-size: 36px;
    color: #fff;
  }

  .but {
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: center;
    color: #6a6a6a;
    width: 100px;
    height: 65px;
    background: #ce1720;
    border: 2px solid #ce1720;
    border-radius: 5px;
    color: white;
    font-weight: 500;
  }
`;

const RightNav = ({ open }) => {
  const userData = useSelector((state) => state.auth.user_data);
  const dispatch = useDispatch();
  return (
    <Container open={open}>
      <Col>
        <Txt color="#fff" bold size={22}>
          {userData?.name}
        </Txt>
        <Txt color="#fff" bold size={12}>
          KAKARECANDO DESDE{' '}
          {userData ? new Date(userData.joinDate).toLocaleDateString('pt-br') : null}
        </Txt>
      </Col>
      <Col align="flex-start" padding="30px">
        <Row>
          <i className="fas fa-cash-register" />
          <Txt color="#fff" size={18} href="/usuario/vendas/abertas">
            MINHAS VENDAS
          </Txt>
        </Row>
        <Col align="flex-start" margin="0 0 0 60px">
          <Txt color="#fff" href="/usuario/vitrine">
            NA VITRINE
          </Txt>
          <Txt color="#fff" href="/usuario/vendas/concluidas">
            VENDIDOS
          </Txt>
        </Col>
        <Row>
          <i className="fas fa-shopping-basket" />
          <Txt color="#fff" size={18} href="/usuario/compras/abertas">
            MINHAS COMPRAS
          </Txt>
        </Row>
        <Row>
          <i className="far fa-heart" />
          <Txt color="#fff" size={18} href="/usuario/favoritos">
            MEUS FAVORITOS
          </Txt>
        </Row>
        <Row>
          <i className="far fa-credit-card" />
          <Txt color="#fff" size={18} href="/usuario/pagamentos">
            PAGAMENTOS
          </Txt>
        </Row>
        <Row>
          <i className="fas fa-cogs" />
          <Txt color="#fff" size={18} href="/usuario/configuracoes/meusdados">
            CONFIGURAÇÃO
          </Txt>
        </Row>
        <Col align="flex-start" margin="0 0 0 60px">
          <Txt color="#fff" href="/usuario/configuracoes/meusdados">
            MEUS DADOS
          </Txt>
          <Txt color="#fff" href="/usuario/configuracoes/emails">
            E-MAIL
          </Txt>
          <Txt color="#fff" href="/usuario/configuracoes/seguranca">
            SEGURANÇA
          </Txt>
        </Col>
      </Col>
      <Link className="but" onClick={() => dispatch(logOut())} to="/">
        Sair
      </Link>
    </Container>
  );
};

export default RightNav;
